export const formatCurrency = value => {
	let formattedValue;

	if (typeof value === 'string') {
		const parsedValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));

		if (!isNaN(parsedValue)) {
			value = parsedValue;
		}
	}

	if (value !== null && value !== undefined && !isNaN(value)) {
		formattedValue = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		}).format(value);
	}

	return formattedValue;
};

export const parseCurrency = val => {
	let cleanedVal = val;
	let parsedVal = 0;

	if (cleanedVal) {
		cleanedVal = cleanedVal.replace(/[^0-9.-]+/g, '');

		if (cleanedVal === '') {
			cleanedVal = 0;
		}

		parsedVal = parseFloat(cleanedVal);
	}

	return parsedVal;
};

export const formatNumber = n => {
	// format number 1000000 to 1,234,567
	return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const parsePercent = val => {
	let cleanedVal = val;

	if (cleanedVal) {
		cleanedVal = cleanedVal.replace(/[^0-9.-]+/g, '');

		if (cleanedVal === '') {
			cleanedVal = '0.0';
		}
	}

	return cleanedVal;
};

export const formatPercent = p => {
	// format percent .222 to 1.222
	return p.replace(/\D/g, '');
};
